import styled, { css } from 'styled-components';
import Flex from '../Flex/Flex';
import theme from '../../assets/styles/theme';

const Content = styled(Flex).attrs({ column: true })`
  height: 100vh;
`;

const Header = styled(Flex)`
  padding: ${theme.spacing['spacing-7']} ${theme.spacing['spacing-6']}
    ${theme.spacing['spacing-7']} ${theme.spacing['spacing-6']};
  position: relative;
  ${({ colors }) => getHeaderSideSheet(colors)}
  ${({ colors }) => getRounderSideSheet(colors)}
`;

const getRounderSideSheet = ({ variant, modifier }) => {
  const defaultVariant = variant == 'neutral' && modifier == 'weak';
  return (
    !defaultVariant &&
    css`
      &:after {
        content: ' ';
        border-radius: ${theme.borderRadius['border-radius-4']}
          ${theme.borderRadius['border-radius-4']} 0px 0px;
        height: 28px;
        position: absolute;
        background-color: ${theme.colors.neutral.bg.weak};
        width: 100%;
        left: 0;
        bottom: 0;
        z-index: 1;
      }
      & {
        padding-bottom: ${theme.spacing['spacing-9']};
      }
    `
  );
};

const Body = styled.div`
  overflow: hidden;
  height: 100%;
`;

const Footer = styled.div`
  margin-top: auto;
  padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-6']}
    ${theme.spacing['spacing-6']} ${theme.spacing['spacing-6']};
`;

const HeaderWrapper = styled.div`
  flex-grow: 1;
  margin-bottom: ${theme.spacing['spacing-1']};
`;

const SubTitleWrapper = styled.div`
  margin-top: ${theme.spacing['spacing-1']};
`;

const CloseIconWrapper = styled.div`
  margin-left: ${theme.spacing['spacing-3']};
`;

const PreviousIconWrapper = styled.div`
  margin-right: ${theme.spacing['spacing-3']};
`;

const TitleWrapper = styled(Flex)`
  ${({ hasPreviousStep }) =>
    hasPreviousStep &&
    css`
      align-items: center;
    `}
  justify-content: space-between;
`;

const getHeaderSideSheet = ({ variant, modifier }) =>
  `background-color: ${theme.colors[variant]?.bg[modifier]};`;

export {
  Content,
  Body,
  Footer,
  HeaderWrapper,
  CloseIconWrapper,
  PreviousIconWrapper,
  TitleWrapper,
  Header,
  SubTitleWrapper,
};
